import ErrorDetails from './component.jsx'
export default ErrorDetails
